import React from 'react';
import { Login } from 'react-admin';
import { LoginPageForm } from './'
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

const styles = ({
  main: { background: '#FFF' },
  card: { 
    width: '100%',
    boxShadow: 'none',
    borderRadius: 0,
    marginTop: 0
  },
  avatar: {
    display: 'none',
  }
});

const LoginPageNoStyles = props => (
  <Login {...props}> 
    <CssBaseline />
    <LoginPageForm/>
  </Login>
);

export const LoginPage = withStyles(styles)(LoginPageNoStyles);